<template>
  <div class="web-page-container">
    <StarTabs :tabs="['配置', '统计分析', '最近任务']" v-model="tabActiveIndex" />

    <div class="web-page-mid">
      <div class="web-page-inner">
        <WemeidaConfig v-if="tabActiveIndex === 0"/>
        <Statistics v-if="tabActiveIndex === 1" />
        <RecentTask v-if="tabActiveIndex === 2" />
      </div>
    </div>
  </div>
</template>

<script>
import WemeidaConfig from '../wemeidaConfig'
import Statistics from '../Statistics'
import RecentTask from '../RecentTask'
import StarTabs from '@/components/StarTabs'

export default {
  components: { WemeidaConfig, Statistics, RecentTask, StarTabs },
  data() {
    return {
      tabActiveIndex: 0
    }
  }
}
</script>

<style lang="less" scoped>
.web-page-container {
  width: 100%;

  .web-page-mid {
    padding: 16px;

    .web-page-inner {
      width: 100%;
    }
  }
}
</style>
